"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseEvmError = void 0;
const constant_1 = require("../../constant");
const isNonceMismatchError = (error) => {
    return error.message.includes('invalid nonce');
};
const isContractExecutionReverted = (error) => {
    return error.message.includes('execution reverted');
};
const parseEvmError = (error, providerAgent) => {
    if (providerAgent === constant_1.ProviderAgent.MetamaskExtension && isNonceMismatchError(error))
        return new Error('Please clear the activity data in your wallet. On your MetaMask Settings > Advanced > Clear activity tab data.');
    if (isContractExecutionReverted(error))
        return new Error('Contract execution reverted. Refer to the console for details.');
    return error;
};
exports.parseEvmError = parseEvmError;
